module.exports = __webpack_public_path__ + "mainassets/img/tile-2-2.7c0c9ad6.jpg";